module.exports = __webpack_public_path__ + "static/media/team-2.2ecfbd87.png";